import { render, staticRenderFns } from "./WebRTCTraffic.vue?vue&type=template&id=0b2ef55e&scoped=true"
import script from "./WebRTCTraffic.vue?vue&type=script&lang=js"
export * from "./WebRTCTraffic.vue?vue&type=script&lang=js"
import style0 from "./WebRTCTraffic.vue?vue&type=style&index=0&id=0b2ef55e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2ef55e",
  null
  
)

export default component.exports